import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect } from "react";
import { useBoundingRect } from "./hooks/useBoundingRect";
import { SButton } from "./components";
// Define a default context value with an explicit type
const defaultContextValue = {
    isOpen: false,
    setIsOpen: ()=>{},
    buttonRect: undefined
};
const MenuContext = /*#__PURE__*/ createContext(defaultContextValue);
const SContextMenu = ({ isOpen, setIsOpen, children })=>{
    const { ref, rect, recalculate } = useBoundingRect();
    // Wrap setIsOpen to recalculate first
    const handleSetIsOpen = (newIsOpen)=>{
        if (newIsOpen) {
            recalculate();
            requestAnimationFrame(()=>{
                setIsOpen(true);
            });
        } else {
            setIsOpen(false);
        }
    };
    return /*#__PURE__*/ _jsx(MenuContext.Provider, {
        value: {
            isOpen,
            setIsOpen: handleSetIsOpen,
            buttonRect: rect
        },
        children: /*#__PURE__*/ _jsx("div", {
            ref: ref,
            children: children
        })
    });
};
SContextMenu.Open = ({ render, children, menu, ...buttonProps })=>{
    const { isOpen, setIsOpen } = useContext(MenuContext);
    return render === undefined ? /*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ _jsx(SButton, {
                ...buttonProps,
                onClick: ()=>{
                    setIsOpen(!isOpen);
                },
                children: children
            }),
            menu
        ]
    }) : /*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            render({
                isOpen,
                setIsOpen
            }),
            menu
        ]
    });
};
SContextMenu.Menu = ({ width, position = "absolute", children, direction = "right" })=>{
    const { isOpen, setIsOpen, buttonRect } = useContext(MenuContext);
    const { ref, rect, recalculate } = useBoundingRect();
    useEffect(()=>{
        recalculate();
    }, [
        isOpen
    ]);
    const menuWidth = width || 375;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                onClick: (e)=>setIsOpen(false),
                className: `fixed ${isOpen ? "" : "pointer-events-none"}  z-[999] top-0 right-0 left-0 bottom-0`
            }),
            isOpen && position == "absolute" && /*#__PURE__*/ _jsx("div", {
                className: `absolute top-[100%] ${direction === "right" ? "right-0" : "left-0"} z-[999]`,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "relative top-[8px] right-0 z-[999]",
                    style: {
                        width: menuWidth
                    },
                    ref: ref,
                    children: children
                })
            }),
            isOpen && position == "fixed" && /*#__PURE__*/ _jsx("div", {
                className: "fixed top-[8px] right-0 z-[1000]",
                style: {
                    width: menuWidth,
                    top: (buttonRect?.top || 0) + (buttonRect?.height || 0) + 10,
                    left: buttonRect?.left
                },
                ref: ref,
                children: children
            })
        ]
    });
};
export default SContextMenu;
